// extracted by mini-css-extract-plugin
module.exports = {"abas":"Abas_abas__2IQtp","aba":"Abas_aba__2V19l","icone":"Abas_icone__2_HJx","ativo":"Abas_ativo__1M4Uo"};